export const categoryFilterOptions = [
  "Biochar",
  "Pasture Renovation",
  "Ph and Structure Renovation",
];
